<template>
  <div>
    <div class="head">
      <h2>{{ $t('mbs-membership') }}</h2>
      <div class="head-btn">
        <div @click="handleAddNewMenber">
          <img src="~img/icon-plus.svg" alt="add" /><span>{{ $t('mbs-add') }}</span>
        </div>
        <div @click="handleSwitchMenber">
          <img src="~img/icon-switch.svg" alt="add" /><span>{{ $t('mbs-switch') }}</span>
        </div>
      </div>
    </div>

    <div class="user-entitlements-wrapper">
      <div class="dp-card">
        <div class="dp-card-logo">
          <img class="visa-logo" src="~img/new-logo-visa.svg" alt="visa logo" />
          <img class="dp-logo" src="~img/icon-dp-logo-light.svg" alt="dragonpass logo" />
        </div>
        <div class="dp-card-qrcode">
          <div id="qr-code" alt="QR code" :class="{ 'no-access': cardList.status === 8 }" />
          <p class="dp-code">
            {{ cardList.status === 8 ? $t('no-access') : formatVisaCardNum(cardList.dragonCode) }}
          </p>
        </div>
        <div class="dp-card-info">
          <div class="dp-card-detail">
            <p>{{ $t('cardholder-name') }}</p>
            <p class="fs-mask">{{ cardList.cardHolder }}</p>
          </div>
          <div class="dp-card-detail">
            <p>{{ $t('entitlement-refresh') }}</p>
            <p>{{ cardList.cardValidDate }}</p>
          </div>
        </div>
      </div>
      <div class="dp-entitlements">
        <div class="dp-entitlements-info">
          <!-- <p class="dp-entitlements-title">Available lounge entitlements</p> -->
          <p class="dp-entitlements-title" v-if="!cardList.mainEquity.paygOnly">
            {{ cardList.mainEquity.equitySubtitleDesc }}
          </p>
          <!-- 无限卡 & 年卡 -->
          <template v-if="cardList.mainEquity.unlimited">
            <p class="dp-entitlements-point" style="font-size: 34px; line-height: 42px">
              {{ $t('unlimited') }}
            </p>
            <div class="dp-entitlements-line">
              <div class="dp-entitlements-line-active" v-for="i in 1"></div>
            </div>
          </template>
          <!-- payg -->
          <template v-else-if="cardList.mainEquity.paygOnly">
            <p class="dp-entitlements-point" style="font-size: 34px; line-height: 42px">
              {{ $t('payg') }}
            </p>
          </template>
          <!-- 点卡 -->
          <template v-else>
            <p class="dp-entitlements-point">
              {{ cardList.mainEquity.equityPointNum }}/{{ cardList.mainEquity.maxPointNum }}
            </p>
            <div class="dp-entitlements-line">
              <div
                class="dp-entitlements-line-active"
                :class="{
                  'dp-entitlements-line-disabled': i > Number(cardList.mainEquity.equityPointNum),
                }"
                v-for="i in Number(cardList.mainEquity.maxPointNum)"
              ></div>
            </div>
          </template>
          <p class="dp-entitlements-desc">{{ cardList.mainEquity.equityDesc }}</p>
          <p
            class="dp-entitlements-desc"
            v-if="cardList.mainEquity.partnerDesc && cardList.mainEquity.partnerPoint"
          >
            <span>{{ cardList.mainEquity.partnerDesc }}</span>
            <span style="font-weight: 700">{{ cardList.mainEquity.partnerPoint }}</span>
          </p>
          <template
            v-if="cardList.mainEquity.equityList && cardList.mainEquity.equityList.length > 0"
          >
            <div class="divide-line"></div>
            <p class="dp-entitlements-desc" v-for="item in cardList.mainEquity.equityList">
              <span>{{ item.title }}</span>
              <span style="font-weight: 700">{{ item.pointNum }}</span>
            </p>
          </template>
        </div>
        <div class="dp-entitlements-tips">
          <img src="~img/icon-circle-tips.svg" alt="tips" />
          <span>{{ $t('mbs-show') }}</span>
        </div>
      </div>
    </div>

    <div class="user-cardinfo-wrapper">
      <div class="visa-card-info">
        <div class="visa-card-details">
          <p class="visa-card-title">{{ $t('linked-visa-card') }}</p>
          <div class="visa-card-box">
            <img src="~img/icon-visa-payment.svg" alt="payment" />
            <div class="visa-card-txt">
              <p>{{ cardList.cardType }}</p>
              <p>{{ cardList.creditCardNo }}</p>
              <p class="fs-mask">{{ cardList.bankCardExpiredDate }}</p>
            </div>
          </div>
        </div>
        <button class="update-visa-card" @click="handleUpdateVisaCard">
          <img src="~img/icon-pencil.svg" alt="update visa card" />
          <span>{{ $t('mbs-btn-update') }}</span>
        </button>
      </div>
      <div class="divider"></div>
      <div class="other-info">
        <p class="other-info-title">{{ $t('card-issuing-bank') }}</p>
        <p class="other-info-desc">{{ cardList.issueName }}</p>
      </div>
      <div class="divider"></div>
      <div class="other-info">
        <p class="other-info-title">{{ $t('membership-number') }}</p>
        <p class="other-info-desc">
          {{ cardList.status === 8 ? $t('no-access') : formatVisaCardNum(cardList.dragonCode) }}
        </p>
      </div>
      <div class="divider"></div>
      <div class="other-info">
        <p class="other-info-title">{{ $t('entitlement-refresh') }}</p>
        <p class="other-info-desc">{{ cardList.cardValidDate }}</p>
      </div>
      <div class="divider"></div>
      <div class="other-info">
        <p class="other-info-title">{{ $t('mbs-note') }}</p>
        <p class="other-info-desc">{{ cardList.tips }}</p>
      </div>
    </div>
    <div class="user-guide-wrapper">
      <p class="user-guide-title">{{ $t('mbs-view-offline') }}</p>
      <p class="user-guide-desc">
        {{ $t('send-or-print-pdf') }}
      </p>
      <div class="user-guide-btn">
        <button @click="handleView(true)">{{ $t('print-pdf') }}</button>
        <button @click="handleEmail">{{ $t('send-pdf') }}</button>
      </div>
    </div>

    <!-- PDF视图弹窗 -->
    <PDFModal v-model:open="showPdfModal" :pdfUrl="pdfUrl" />
  </div>
</template>

<script>
  // import PdfDialog from '@/components/PDF';
  import PDFModal from './PDFModal.vue';
  import QRCode from 'qrcodejs2';
  import { mapMutations, mapState } from 'vuex';

  // const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));

  export default {
    components: {
      // PdfDialog,
      PDFModal,
    },

    mounted() {
      this.getAccountList();
    },

    data() {
      return {
        cardList: {
          mainEquity: {
            maxPointNum: '6',
            equityPointNum: '6',
          },
        },
        showPdfModal: false,
        pdfUrl: new Blob(),
      };
    },

    computed: {
      ...mapState(['userInfo']),
    },

    methods: {
      handleEmail() {
        this.sendMemberCardEmail();
      },

      handleView(data) {
        if (data) {
          this.getMemberShipPdf(() => {
            this.showPdfModal = Boolean(data);
          });
        }
      },

      // 获取membership页面数据
      getAccountList() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          // device: 'web',
          // version: '1.0.0',
          lang: this.$i18n.locale,
          sessionId,
          // deviceName,
          deviceId: localStorage.getItem('deviceId') || '',
        };
        this.$http.member.getAccountList(data).then(
          res => {
            if (res.state === '11') {
              const selectedCard = res.payload.find(item => item.isSelected === '1');
              this.cardList = selectedCard;
              this.setState({
                state: 'currentDpCard',
                values: selectedCard,
              });
              this.$nextTick(() => {
                this.qrcode(selectedCard);
              });
            } else {
              console.error(res);
            }
          },
          err => {
            console.error(err);
          },
        );
      },

      // 二维码转换(兼容安卓手机无法通过css更改大小的问题)
      qrcode(data) {
        window.innerWidth > 1024
          ? new QRCode('qr-code', {
              width: 240,
              height: 240,
              text: data.qrCode,
              colorDark: '#000',
              colorLight: '#fff',
            })
          : new QRCode('qr-code', {
              width: 126,
              height: 126,
              text: data.qrCode,
              colorDark: '#000',
              colorLight: '#fff',
            });
      },

      // 获取会员PDF
      getMemberShipPdf(callback) {
        const { userId, sessionId } = this.userInfo;

        this.$http.member
          .getMemberShipPdf({ userId, sessionId })
          .then(res => {
            this.pdfUrl = res;
            callback && callback();
          })
          .catch(err => {
            console.error(err);
          });
      },

      // 发送会籍卡PDF至Email
      sendMemberCardEmail() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
          lang: this.$i18n.locale,
        };
        console.log(data);
        this.$http.member
          .sendMemberCardEmail(data)
          .then(res => {
            if (res.state === '11') {
              this.showMessageModal({ key: 'mbs-email-msg1', i18nNeed: true });
            } else {
              res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
              console.error(res.note);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },

      handleSwitchMenber() {
        this.$router.push({ path: '/account/switchmembership' });
      },

      handleAddNewMenber() {
        this.$router.push({ path: '/addnewmembership' });
      },

      handleUpdateVisaCard() {
        this.$router.push({ path: '/updatevisacard' });
      },
      formatVisaCardNum(num) {
        return num
          ? num
              .replace(/\s/g, '')
              .replace(/[^\d]/g, '')
              .replace(/(\d{4})(?=\d)/g, '$1 ')
          : '';
      },

      ...mapMutations(['showMessageModal', 'setState']),
    },
  };
</script>

<style lang="scss">
  #qr-code {
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
